import React, { Component } from "react";
import ModalForm from './Modal';
import DataTable from './Table';
import Loader from '../../../container/Loader';
import Pagination from 'react-js-pagination';

import Home from '../../../container/Home';

import api from "../../../services/api";
import { getToken } from "../../../services/auth";

import "../../../styles/usuarios.css";

export default class List extends Component {

    constructor(props) {
        super(props);
            this.state = {
                loading: true,
                juridicas: [],
                url: `/juridica`,
                showStore: true,
                search: null,
                pageSize: 10,
                pageNumeber: 1
            };
        this.pageSizes = [10, 20, 30, 40, 50];
    }

    async getJuridicas() {
        
        const token = getToken()
        const items = this.state.pageSize
        const response = await api.get(`${this.state.url}?page=${this.state.pageNumeber}`, { headers: { token, items } })
        this.setState({juridicas: response.data, loading: false})
    }

    componentDidMount() {
        this.getJuridicas()
    }

    searchSpace = (event) => {
        let keyword = event.target.value;
        this.setState({ search: keyword })
    }

    handlePageSizeChange = (event) => {
        this.setState(
          {
            pageSize: event.target.value,
            pageNumeber: 1
          },
          () => {
            this.getJuridicas();
          }
        );
    }

    handlePageChange = (pageNumeber) => {
        this.setState(
          {
            pageNumeber: pageNumeber,
          },
          () => {
            this.getJuridicas();
          }
        );
      }

    render() {
        if (this.state.loading) return <Loader />;
        const {data, current_page, per_page, total} = this.state.juridicas
        // eslint-disable-next-line
        const items = (data || []).filter(data => {
            if (this.state.search == null)
                return data
            else if (data.cnpj.toLowerCase().includes(this.state.search.toLowerCase()) ||
                     data.razao_social.toLowerCase().includes(this.state.search.toLowerCase())) {
                return data
            }
        })
        return (
            <Home menu={true} client={true} html={
                <>
                    <div>
                        <div className="usuarios-header">
                            <h4>GESTÃO DE CLIENTES</h4>
                                <ModalForm buttonLabel="NOVO" buttonId="novo" className="modal-lg" />
                        </div>
                    </div>
                    <div className="lista-usuarios-wrapper">
                        <div className="barra-filtro">
                            <div className="barra-filtro-right">
                                <div className="barra-pesquisa">
                                    <input type="text" className="form-control col-12" placeholder="CNJP ou Razão Social"
                                        onChange={(e) => this.searchSpace(e)} />
                                </div>                               
                            </div>
                        </div>
                        <div className="table-responsive">
                            <DataTable datas={items} /> 
                            <div className="usuarios-header">
                            <div className="row">
                                <div className="col-sm-2">
                                <p style={{padding: '5px 0'}}>Mostrar</p>
                                </div>
                                <div className="col-sm-2">
                                <select className="form-control" style={{width: "65px", display: "unset"}} onChange={this.handlePageSizeChange} value={this.state.pageSize}>
                                {this.pageSizes.map((size) => (<option key={size} value={size}>{size}</option>))}
                                </select>
                                </div>
                                <div className="col">
                                <p style={{padding: '5px 5px'}}>registros por página</p>
                                </div>
                            </div>                                
                            <>
                            <Pagination
                                firstPageText={<i className="fa fa-angle-double-left" aria-hidden="true"></i>}
                                lastPageText={<i className="fa fa-angle-double-right" aria-hidden="true"></i>}
                                prevPageText={<i className="fa fa-chevron-left" aria-hidden="true"></i>}
                                nextPageText={<i className="fa fa-chevron-right" aria-hidden="true"></i>}
                                itemClass="page-item"
                                linkClass="page-link"
                                activePage={current_page}
                                totalItemsCount={total}
                                itemsCountPerPage={JSON.parse(per_page)}
                                onChange={(pageNumeber) => this.handlePageChange(pageNumeber)}
                            />
                            </>
                        </div>                      
                        </div>
                    </div>
                </>
            } />
        )
    }
}
